import Button from "../../components/updatedComponents/Dealers/Button";
import { CloseIcon } from "../../components/icons/Icon2";
import { Pack } from "../../components/icons/Icon";
import styles from "./PackConfirmModal.module.css";

const PackConfirmModal = ({
  mode,
  heading = "Pack Voucher",
  centerHeading = "Are you sure you want to pack this voucher?",
  packCount = 0,
  loading = false,
  handleSubmit,
  handleCloseModal,
}) => {
  return (
    <div className={`${styles.modal} ${mode ? styles.dark : ""}`}>
      {/* Header */}
      <div className={styles.header}>
        <p className={styles.title}>{heading}</p>
        <div
          className={`${styles.closeBtn} ${loading ? styles.disabled : ""}`}
          onClick={() => !loading && handleCloseModal()}
        >
          <CloseIcon mode={mode} />
        </div>
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.iconCircle}>
          <Pack color={mode ? "#FFFFFF" : "#4164E3"} />
        </div>

        <p className={styles.centerHeading}>{centerHeading}</p>
        <p className={styles.packLine}>
          Total {packCount === 1 ? "Pack" : "Packs"}:{" "}
          <span className={styles.packNum}>{packCount}</span>
        </p>
      </div>

      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.btnWrap}>
          <Button
            buttonBgColor={"#000000"}
            buttonTextColor={"#FFFFFF"}
            buttonText={"No"}
            buttonClick={handleCloseModal}
            disabled={loading}
          />
        </div>
        <div className={styles.btnWrap}>
          <Button
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#FFFFFF"}
            buttonText={"Yes"}
            buttonClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default PackConfirmModal;
